<template>
  <pict
    class="purchase-image__image"
    block-name="purchase-image"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageLEN from "./images/desktop-en.png"
import imageL2xEN from "./images/desktop-en@2x.png"
import imageSEN from "./images/mobile-en.png"
import imageS2xEN from "./images/mobile-en@2x.png"
import imageLDE from "./images/desktop-de.png"
import imageL2xDE from "./images/desktop-de@2x.png"
import imageSDE from "./images/mobile-de.png"
import imageS2xDE from "./images/mobile-de@2x.png"
import imageL2xES from "./images/desktop-es@2x.png"
import imageS2xES from "./images/mobile-es@2x.png"

export default {
  name: "PurchaseImage",
  components: {
    Pict
  },
  data: () => ({
    images: {
      en: {
        l: imageLEN,
        l2x: imageL2xEN,
        xs: imageSEN,
        xs2x: imageS2xEN
      },
      de: {
        l: imageLDE,
        l2x: imageL2xDE,
        xs: imageSDE,
        xs2x: imageS2xDE
      },
      es: {
        l: imageL2xES,
        l2x: imageL2xES,
        xs: imageS2xES,
        xs2x: imageS2xES
      }
    }
  }),
  computed: {
    imageProps() {
      return {
        default: {
          src: this.images[this.$i18n.locale].l,
          srcset: {
            "2x": this.images[this.$i18n.locale].l2x
          }
        },
        sources: [
          {
            media: "s",
            src: this.images[this.$i18n.locale].xs,
            srcset: {
              "2x": this.images[this.$i18n.locale].xs2x
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "A screenshot of the Blinkist Mobile App"
      },
      de: {
        alt: "Ein Screenshot der Blinkist Mobile App"
      },
      es: {
        alt: "Una captura de pantalla de la aplicación móvil de Blinkist"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.purchase-image {
  ::v-deep &__image {
    width: 100%;
  }
}
</style>
